// import { ColorPickerComponent } from '@syncfusion/ej2-react-inputs';
// import * as React from "react";
// // import * as ReactDOM from "react-dom";


// export default class Comp extends React.Component {


//     constructor(props) {
//         super(props);
//         this.onCreated = this.onCreated.bind(this);
//     }
//     onCreated() {
//         const cpElem = this.colorPicker.element.nextElementSibling;
//         cpElem.insertBefore(this.colorPicker.element, cpElem.children[1]);
//     }


//     render() {
//         return (
//         <div id='container'>
//             <div className='wrap'>
//                 <h4>Choose Color</h4>
//                 <ColorPickerComponent ref={(scope) => this.colorPicker = scope}
//                     id='colorpicker'
//                     type='text'
//                     created={this.onCreated}
//                     className='e-input' />

//             </div>

//         </div>
//         );
//     }
// }


import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';




import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

const useStyles = makeStyles({
  grid: {
    width: '60%',
  },
});

export default function Comp() {
  // The first commit of Material-UI
  const [selectedDate, setSelectedDate] = React.useState(new Date('2014-08-18T21:11:54'));

  const classes = useStyles();

  function handleDateChange(date) {
    setSelectedDate(date);
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container className={classes.grid} justify="space-around">
        <KeyboardDatePicker
          margin="normal"
          id="mui-pickers-date"
          label="Date picker"
          value={selectedDate}
          onChange={handleDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
        <KeyboardTimePicker
          margin="normal"
          id="mui-pickers-time"
          label="Time picker"
          value={selectedDate}
          onChange={handleDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change time',
          }}
        />
      </Grid>
    </MuiPickersUtilsProvider>
  );
}


